module.exports = __webpack_public_path__ + "624c1255/img/34000000-7.b91fb151.png";